import { Card, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { ProjectDeliverablesMap_FeatureFragment } from "../../fragments.generated";
import { ProjectDeliverablesMapView } from "./ProjectDeliverablesMapView";

type DeliverableMap = {
    title: string;
    features: ProjectDeliverablesMap_FeatureFragment[];
};

type Props = {
    map: DeliverableMap;
};

export function ProjectDeliverablesMap({ map }: Props) {
    const { t } = useTranslation("project");

    return (
        <Stack spacing={1}>
            <Typography variant="subtitle1">{map.title}</Typography>
            <Card variant="outlined" sx={{ padding: 1 }}>
                {map.features.length > 0 ? (
                    <ProjectDeliverablesMapView features={map.features} />
                ) : (
                    <Typography variant="body2" sx={{ margin: 2 }}>
                        {t("deliverablesScreen.noData")}
                    </Typography>
                )}
            </Card>
        </Stack>
    );
}
